import { render } from "./TheSlider.vue?vue&type=template&id=a9cebd98&scoped=true"
import script from "./TheSlider.vue?vue&type=script&lang=js"
export * from "./TheSlider.vue?vue&type=script&lang=js"

import "./TheSlider.vue?vue&type=style&index=0&id=a9cebd98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cebd98"]])

export default __exports__